/**
 * ConflictNotification
 * Toast notification for concurrent edit conflicts
 * Feature: User Management (002-user-management) - Phase 3
 */

import React from 'react';
import './ConflictNotification.css';

const ConflictNotification = ({ conflicts, onDismiss }) => {
  if (!conflicts || conflicts.length === 0) return null;

  const formatTime = (timestamp) => {
    try {
      return new Date(timestamp).toLocaleTimeString();
    } catch {
      return 'Unknown time';
    }
  };

  return (
    <div className="conflict-notification">
      <div className="conflict-header">
        <span className="conflict-icon">⚠️</span>
        <h3>Concurrent Edit Detected</h3>
        <button className="conflict-close" onClick={onDismiss} aria-label="Dismiss">
          ×
        </button>
      </div>
      
      <div className="conflict-body">
        <p className="conflict-summary">
          {conflicts.length} session{conflicts.length > 1 ? 's were' : ' was'} modified by another user. 
          Your changes have been saved and will overwrite theirs.
        </p>
        
        <ul className="conflict-list">
          {conflicts.map((conflict, index) => (
            <li key={index} className="conflict-item">
              <strong>{conflict.sessionName}</strong>
              <span className="conflict-time">
                Modified at {formatTime(conflict.dbUpdatedAt)}
              </span>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="conflict-footer">
        <button className="btn-dismiss" onClick={onDismiss}>
          I Understand
        </button>
      </div>
    </div>
  );
};

export default ConflictNotification;
